import React, { useRef, useState } from 'react';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import ClickHandler from '@nykaa/deals-utils/clicks';
import { DEFAULT_ROOT_MARGIN } from '@nykaa/deals-utils/impressions/constants';
import IoElement from '../IOElement';
import Timer from '../Timer';
import { handleRightClickCallback } from '../../helper';
import CONSTANTS from './constants';
/* eslint-disable react/jsx-props-no-spreading */
import { getDetailsClass, isTextVisible, isTitleFirst, isVideoType, isCalloutVisible, isTagTypeVisible, } from './helpers';
import Iframe from '../Iframe';
// import { isValidUrl } from '../../helper';
import { Wrapper, BottomLogo, CalloutWrapper, ContentWrapper, DetailsWrapper, TextAreaWrapper, } from './css';
import widgetTypes from '../../constants/widgetTypes';
import { adTypes } from '../../constants';
const getTitleInOrder = (titleOrder, title, discountTitle) => {
    const spanElements = [];
    const discountElement = (discountTitle) && (React.createElement("span", { key: "discountTile", className: "discount-text" }, discountTitle));
    const titleElement = (title) && (React.createElement("span", { key: "palintitle", className: "title-text" }, title));
    if (isTitleFirst(titleOrder)) {
        spanElements.push(titleElement);
        spanElements.push(discountElement);
    }
    else {
        spanElements.push(discountElement);
        spanElements.push(titleElement);
    }
    return spanElements;
};
const displayIframe = (url) => (React.createElement(Iframe, { title: `${url}`, width: "100%", height: "100%", src: url, frameBorder: "0", allowFullScreen: true }));
const videoMetaDetails = CONSTANTS.videoParams;
const BannerV2 = (widgetData) => {
    const [isIframe, setIframe] = useState(false);
    const outlineRef = useRef(null);
    const { params, children, isServer, trackingData, cssStyle, id, isDesktop, isDevModeEnabled, devModeData, rootMargin, pwType, cwType, } = widgetData;
    const { url, title, discountTitle, titleOrder, textPosition, description, subDescription, textAreaOpacity, actionType, callOut, callOut2, callOut3, tagText, tagTimerEnd, timerEndText, tagType, appLinkData, appLinkType, adType, videoAdType, trackingParams, } = params;
    const isVideoWidget = (cwType === widgetTypes.VIDEO || adType === adTypes.VIDEO);
    const handleForClickTrigger = (e) => {
        e.stopPropagation();
        return outlineRef.current.click();
    };
    const ad_type = isVideoWidget ? adTypes.VIDEO : adTypes.IMAGE;
    const trackingDataWithAdType = Object.assign(Object.assign({}, trackingData), { ad_type });
    const videoTrackingData = Object.assign(Object.assign({}, trackingDataWithAdType), { video_ad_type: videoAdType, video_total_duration: videoMetaDetails.video_duration, video_view_duration: videoMetaDetails.view_duration });
    const DetailsClass = getDetailsClass(textPosition);
    const showText = isTextVisible(params);
    const showCallout = isCalloutVisible(params);
    const showTagType = isTagTypeVisible(params);
    const widgetTrackingData = isVideoWidget ? videoTrackingData : trackingDataWithAdType;
    const handleIntersect = () => {
        ImpressionsHandler.handleImpression(widgetTrackingData);
    };
    const handleIntersectV2 = () => {
        ImpressionsHandler.handleImpressionV2(widgetTrackingData);
    };
    const clickHandler = (trackingDetails) => {
        if (!isVideoType(actionType)) {
            ImpressionsHandler.handleClick(trackingDetails)
                .finally(() => {
                /**
                 * ? Why finally?
                 * even in case of an error in handling impression...
                 * we would want the click to function as expected
                 */
                ClickHandler.handleClick({
                    appLinkData,
                    appLinkType,
                    trackingParams,
                    webActionType: actionType,
                    webActionUrl: url,
                });
                // setting the value back to the initial
                videoMetaDetails.video_duration = 0;
                videoMetaDetails.view_duration = 0;
                // if (isValidUrl(url)) {
                // window.location.href = url;
                // }
            });
        }
        else {
            setIframe(true);
        }
    };
    const exitCallBackHandler = () => {
        ImpressionsHandler.removeImpression(trackingData);
    };
    const { childBannerStyle, childTextAreaStyle } = cssStyle;
    const isNewTemplate = !!((childBannerStyle === null || childBannerStyle === void 0 ? void 0 : childBannerStyle.individualCornerRadius) || (childTextAreaStyle === null || childTextAreaStyle === void 0 ? void 0 : childTextAreaStyle.individualCornerRadius)
        || childTextAreaStyle.individualBorders);
    const devModeHandler = (!!isDevModeEnabled && {
        onContextMenu: () => handleRightClickCallback(devModeData),
    });
    const handleVideo = (totalDuration, currentViewedTime) => {
        clickHandler(Object.assign(Object.assign({}, videoTrackingData), { video_total_duration: totalDuration, video_view_duration: currentViewedTime }));
    };
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { outlineRef, handleVideo });
        }
        return child;
    });
    const parentClickHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        clickHandler(trackingDataWithAdType);
    };
    const isVideoWidgetClickHandler = isVideoWidget ? handleForClickTrigger : parentClickHandler;
    return (React.createElement(React.Fragment, null,
        React.createElement(IoElement, { isServer: isServer, onIntersect: handleIntersect, exitCallBack: exitCallBackHandler, onIntersectV2: handleIntersectV2, rootMargin: pwType === widgetTypes.CAROUSEL_V2 ? rootMargin : DEFAULT_ROOT_MARGIN },
            React.createElement(Wrapper, Object.assign({ bannerCss: cssStyle, id: id, className: "banner-container", onClick: isVideoWidgetClickHandler }, devModeHandler),
                React.createElement(ContentWrapper, { isNewTemplate: isNewTemplate, bannerCss: cssStyle },
                    isIframe && displayIframe(url),
                    React.createElement("div", { className: "image-tag-wrapper" },
                        !isIframe && (React.createElement("div", { className: "image-container" },
                            React.createElement("div", { className: "card-view" }),
                            React.createElement("div", { className: "image-with-logo" }, childrenWithProps),
                            showCallout && (React.createElement(CalloutWrapper, { isDesktop: isDesktop, callout: callOut, callout2: callOut2, callout3: callOut3, cssCallout: cssStyle.childCalloutStyle, className: "callout-radius" },
                                callOut && React.createElement("div", { className: "callout-text" }, callOut),
                                callOut2 && (React.createElement("div", { className: "callout-text2" }, callOut2)),
                                callOut3 && (React.createElement("div", { className: "callout-text3" }, callOut3)))))),
                        showTagType && (React.createElement(Timer, { timeStamp: parseInt(tagTimerEnd, 10) * 1000, timerEndText: timerEndText, tagText: tagText, tagTimerEnd: tagTimerEnd, tagType: tagType })),
                        React.createElement("div", { onClick: isVideoWidgetClickHandler, className: "outline-wrapper" })),
                    showText && (React.createElement("div", { className: "edgetoedgetextarea" },
                        React.createElement(BottomLogo, { bannerCss: cssStyle },
                            React.createElement("div", { className: "image-with-logo" }, children[1])),
                        React.createElement(TextAreaWrapper, { isNewTemplate: isNewTemplate, styleTextarea: cssStyle.childTextAreaStyle },
                            React.createElement(DetailsWrapper, { styleTextarea: cssStyle, opacity: textAreaOpacity },
                                React.createElement("div", { className: DetailsClass },
                                    React.createElement("div", { className: "titles-wrap" }, getTitleInOrder(titleOrder, title, discountTitle).map((span) => span)),
                                    description && (React.createElement("div", { className: "description" }, description)),
                                    subDescription && (React.createElement("div", { className: "sub-description" }, subDescription))))))))))));
};
export default BannerV2;
